import { QueryPageResult, http } from '@kunlun/dependencies';

export interface Draft {
  id?: string;
  viewName?: string;
  content: string;
}

export const editDraft = async (draft: Draft, isPlatform = false) => {
  const gql = `
    mutation {
      deliAries${isPlatform ? 'Platform' : 'Seller'}StagingFrontMutation {
        ${isPlatform ? 'create' : 'save'} (data: {
          ${draft.id ? `id: "${draft.id}"` : ''}
          ${draft.viewName ? `viewName: "${draft.viewName}"` : ''}
          content: ${draft.content}
        }) {
          id
          viewName
          content
        }
      }
    }
  `;
  const res = await http.mutate<Draft>('AriesStagingFront', gql);
  return res.data[`deliAries${isPlatform ? 'Platform' : 'Seller'}StagingFrontMutation`].create;
};

export const queryDraft = async (viewName: string, isPlatform = false) => {
  const gql = `
    query {
      deliAries${isPlatform ? 'Platform' : 'Seller'}StagingFrontQuery {
        queryOne (
          query: {
            viewName: "${viewName}"
          }
        ) {
          id
          viewName
          content
          createDate
        }
      }
    }
  `;
  const res = await http.query<Draft>('AriesStagingFront', gql);
  return res.data[`deliAries${isPlatform ? 'Platform' : 'Seller'}StagingFrontQuery`].queryOne;
};
